import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";
import {
  createFileRoute,
  useNavigate,
  useRouter,
  useSearch,
} from "@tanstack/react-router";
import { useGraphQL } from "@/hooks/use-graphql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { FollowUpAppointmentReminderList } from "@/components/assist/follow-up-appointment-reminder/follow-up-appointment-reminder-list";
import { DeleteFollowUpAppointmentReminderDrawer } from "@/components/assist/follow-up-appointment-reminder/delete-follow-up-appointment-reminder-drawer";
import { AssistFeatures } from "@/enums/assist-features";
import { validateFeatureAccess } from "@/lib/assist-feature-guard";
import { formatWithZonedDate } from "@/lib/helpers/date";
import { ReminderType } from "@/lib/enums/reminder-type";

import type { JSX } from "react";

const FollowUpAppointmentReminderPageQuery = graphql(/* GraphQL */ `
  query FollowUpAppointmentReminderPageQuery(
    $codTipoLembreteRetorno: Int!
    $hoje: datetime2!
  ) {
    ...FollowUpAppointmentReminderListQuery
  }
`);

const FollowUpAppointmentReminderPage = (): JSX.Element => {
  const router = useRouter();
  const navigate = useNavigate();
  const params = useSearch({
    from: "/settings/assist/follow-up-appointment-reminder/",
  });
  const { navigateBack } = params;

  const queryResult = useGraphQL(FollowUpAppointmentReminderPageQuery, {
    codTipoLembreteRetorno: ReminderType.FollowUpAppointment.valueOf(),
    hoje: formatWithZonedDate(new Date()),
  });
  const { data } = queryResult;

  const onBackButtonClick = (): void => {
    if (navigateBack) {
      router.history.back();
    } else {
      void navigate({ to: "..", search: params });
    }
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton onClick={onBackButtonClick} icon={Left} align="start" />
        <HeaderTitle title="Lembrete de retorno" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <FollowUpAppointmentReminderList data={data} /> : null}
          <DeleteFollowUpAppointmentReminderDrawer />
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/assist/follow-up-appointment-reminder/")({
  component: FollowUpAppointmentReminderPage,
  beforeLoad: ({ context, location }) => {
    validateFeatureAccess({
      location,
      user: context.user,
      codFuncionalidade: AssistFeatures.FollowUpAppointmentReminder,
    });
  },
});
